import { render, staticRenderFns } from "./editComment.vue?vue&type=template&id=5eedca87&scoped=true&"
import script from "./editComment.vue?vue&type=script&lang=js&"
export * from "./editComment.vue?vue&type=script&lang=js&"
import style0 from "./editComment.vue?vue&type=style&index=0&id=5eedca87&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eedca87",
  null
  
)

export default component.exports